module.exports = __webpack_public_path__ + "static/media/t-8-q-9.1b1213b9.jpg";